import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { CommonTarget } from './common-targeting';

export const CompanyName = ({ companyTargets, negativeCompanyTargets }) => {
  const i18n = useContext(I18nContext);

  return (
    <CommonTarget label={_TL_('Company')} includedData={companyTargets} excludedData={negativeCompanyTargets} singularText={i18n.getString(_TL_('company'))} pluralText={i18n.getString(_TL_('companies'))} />
  );
};

CompanyName.propTypes = {
  companyTargets: PropTypes.arrayOf(PropTypes.shape({})),
  negativeCompanyTargets: PropTypes.arrayOf(PropTypes.shape({})),
};

CompanyName.defaultProps = {
  companyTargets: [],
  negativeCompanyTargets: [],
};
